import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { PageRoutes, ProfileRoutes, useViewModel } from '@utils';
import { Loader, PageWrapper, Version } from '@components';
import { ProfileViewModel } from './ProfileViewModel';
import { Tabs } from '../../components/tabs';
import '../../styles/views/profilePage/profilePage.scss';

export const ProfilePageDesktop: FC = observer(() => {
  const profileViewModel = useViewModel(ProfileViewModel);

  return (
    <PageWrapper>
      {profileViewModel.isLoading
        ? (
          <div className="loader-wrapper">
            <Loader />
          </div>
        )
        : (
          <div className="profile-page">
            <div className="profile-page-content">
              <h1>Настройки аккаунта</h1>
              <div>
                <div className="avatar-info-box flex gap-8">
                  <img src={profileViewModel.profileInfo.img} alt="Profile" className="profile-page-avatar" />
                  <div className="fullname-info">
                    <p className="name">{profileViewModel.profileInfo.fullName}</p>
                    <p className="email">{profileViewModel.profileInfo.corporateEmail}</p>
                  </div>
                </div>
                <div className="profile-tabs">
                  <Tabs
                    links={
                    [
                      { title: 'Детали профиля', route: PageRoutes.PROFILE_PAGE },
                      { title: 'Мои календари', route: `${PageRoutes.PROFILE_PAGE}/${ProfileRoutes.CONNECTED_CALENDARS_TAB}` },
                      { title: 'Настройка уведомлений', route: `${PageRoutes.PROFILE_PAGE}/${ProfileRoutes.NOTIFICATIONS_TAB}` },
                    ]
                  }
                  />
                </div>
              </div>
            </div>
            <Version />
          </div>
        )}
    </PageWrapper>
  );
});
